// Cab Watcher Actions
export const GET_CAB_BOOKING_WATCHER = "GET_CAB_BOOKING_WATCHER"

export const CREATE_CAB_BOOKING_WATCHER = "CREATE_CAB_BOOKING_WATCHER"

//..............................................................................................................................................//

// Cab Reducer Actions
export const CAB_LIST = "CAB_LIST"